export const prefix = 'Action';
export var Type;
(function (Type) {
    Type["PostFirstFactorVerification"] = "PostFirstFactorVerification";
    Type["PostSignIn"] = "PostSignIn";
})(Type || (Type = {}));
